import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import SaleRoutes from '../sale/SaleRoutes';
import PurchaseRoutes from '../purchase/PurchaseRoutes';
import DashboardRoutes from '../dashboard/DashboardRoutes';
import InboxRoutes from '../inbox/InboxRoutes';
import AppWithPersistentNav from './App';
import HomePage from './HomePage';
import BankAccountsPage from '../bank/BankAccountsPage';
import SettingsPage from '../settings/SettingsPage';
import LoginPage from './LoginPage';
import { AuthProvider } from '../auth';
import { CurrentCompanyProvider } from '../auth/CurrentCompany';
import PlaygroundPage from './PlaygroundPage';
import BankTransactionsPage from '../bank/BankTransactionsPage';

type Props = {
  showNavigation?: boolean;
}

const AppRoutes: React.FC<Props> = (props) => {
  console.log('playground');
  return (
    <Routes>
        <Route path="login" element={<LoginPage/>}/>
        <Route
          path="*"
          element={<AppWithPersistentNav showNavigation={props.showNavigation}>
            <Routes>
              <Route path="" element={<PlaygroundPage/>} />
              <Route path="inbox" element={<InboxRoutes/>} />
              <Route path="dashboard" element={<DashboardRoutes/>} />
              <Route path="bank-accounts" element={<BankAccountsPage/>} />
              {/*<Route path="bank/:id" element={<BankTransactionsPage/>} />*/}
              {/*<Route path="bank/rules" element={<div/>}/>*/}
              <Route path="sale/*" element={<SaleRoutes/>} />
              <Route path="purchases/*" element={<PurchaseRoutes/>} />
              <Route path="settings" element={<SettingsPage/>} />
            </Routes>
          </AppWithPersistentNav>}
        />

      </Routes>
  )

};

export default AppRoutes;
